import { fmt, ddmmyyyy } from "@/lib/format";
import { monthLabel } from "@/pages/SummaryPage";

export const CashoutStatement = ({ data }) => (
  <>
    <header className="flex items-end justify-between gap-4 border-b-2 border-slate-900 pb-3 mb-5">
      <div>
        <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">Daily Balance Book · Cashout report</p>
        <h1 className="text-2xl font-extrabold tracking-tight" data-testid="cashout-print-month">{monthLabel(data.month)}</h1>
      </div>
      <div className="text-right">
        <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500">Total cashout</p>
        <p className="font-mono text-xl font-bold tabular-nums" data-testid="cashout-print-total">{fmt(data.total)}</p>
      </div>
    </header>
    <section className="print-avoid-break mb-6">
      <h2 className="text-sm font-bold uppercase tracking-[0.12em] mb-1.5">Totals per person</h2>
      <table className="w-full max-w-md text-[11px] border-collapse border border-slate-400" data-testid="cashout-print-people">
        <tbody>
          {data.people.map((p) => (
            <tr key={p.name}>
              <td className={`border border-slate-300 px-2 py-1 font-semibold ${p.unassigned ? "italic text-slate-500" : ""}`}>{p.name}</td>
              <td className="border border-slate-300 px-2 py-1 text-right text-slate-500">{p.count}×</td>
              <td className="border border-slate-300 px-2 py-1 text-right font-mono tabular-nums font-bold">{fmt(p.total)}</td>
            </tr>
          ))}
          <tr className="bg-slate-100 font-bold">
            <td className="border border-slate-400 px-2 py-1">TOTAL</td>
            <td className="border border-slate-400 px-2 py-1 text-right">{data.items.length}×</td>
            <td className="border border-slate-400 px-2 py-1 text-right font-mono tabular-nums">{fmt(data.total)}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section className="print-avoid-break">
      <h2 className="text-sm font-bold uppercase tracking-[0.12em] mb-1.5">All cashouts</h2>
      <table className="w-full text-[11px] border-collapse border border-slate-400" data-testid="cashout-print-items">
        <thead>
          <tr className="bg-slate-100">
            {["Date", "Book", "Paid to", "Description", "Cashout"].map((h) => <th key={h} className={`border border-slate-400 px-2 py-1 font-bold uppercase ${h === "Cashout" ? "text-right" : "text-left"}`}>{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.items.map((it) => (
            <tr key={it.entry_id}>
              <td className="border border-slate-300 px-2 py-1 font-mono whitespace-nowrap">{ddmmyyyy(it.date)}</td>
              <td className="border border-slate-300 px-2 py-1 uppercase font-semibold">{it.book_name}{it.sheet === "sett" ? " · SETT" : ""}</td>
              <td className="border border-slate-300 px-2 py-1 font-semibold">{it.cashout_to || "—"}</td>
              <td className="border border-slate-300 px-2 py-1">{it.cashout_note}</td>
              <td className="border border-slate-300 px-2 py-1 text-right font-mono tabular-nums">{fmt(it.cashout)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
    <footer className="mt-10 pt-3 border-t border-slate-300 flex justify-between text-[10px] text-slate-500">
      <span>Printed {ddmmyyyy(new Date().toISOString().slice(0, 10))}</span>
      <span>Checked by: ____________________</span>
    </footer>
  </>
);
